import * as Snackbar from '@synergy/shared/snackbar/data-access';
import { API_BASE_URL } from '@synergy/config';
import { PoolNotification } from '@synergy/shared/snackbar/data-access';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { BonusSettlementsDetailApi } from '../api/bonus-settlements-detail-api';

const api = new BonusSettlementsDetailApi(API_BASE_URL);

export const customerBonusSettlementDetailsReset = createAction('bonusSettlement/details-reset');
export const customerBonusSettlementSuppliersReset = createAction('bonusSettlement/suppliers-reset');

export const getCustomerBonusSettlementDetail = createAsyncThunk(
    'bonusSettlement/details',
    async (id: number, thunkAPI) => {
        const response = await api.getCustomerBonusSettlementDetails(id);

        if (response.success) {
            return response.result;
        }

        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));

        return null;
    }
);

export const getPoolCustomerBonusSettlementDetail = createAsyncThunk(
    'bonusSettlement/pool-details',
    async (id: number, thunkAPI) => {
        const response = await api.getPoolCustomerBonusSettlementDetails(id);

        if (response.success) {
            return response.result;
        }

        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));

        return null;
    }
);

export const getCustomerBonusSettlementSuppliers = createAsyncThunk(
    'bonusSettlement/suppliers',
    async ({ id, searchParams }: { id: number; searchParams?: URLSearchParams }, thunkAPI) => {
        const response = await api.getBonusSettlementSuppliers(id, searchParams);

        if (response.success) {
            return response.result;
        }
        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));

        return null;
    }
);

export const getPoolCustomerBonusSettlementCustomers = createAsyncThunk(
    'bonusSettlement/pool-customers',
    async ({ id, searchParams }: { id: number; searchParams?: URLSearchParams }, thunkAPI) => {
        const response = await api.getPoolBonusSettlementCustomers(id, searchParams);

        if (response.success) {
            return response.result;
        }
        thunkAPI.dispatch(Snackbar.enqueue(PoolNotification.error('app.snackbar.error')));

        return null;
    }
);
